<template>
  <div>
    <page-header
      icon="mdi-store"
      :title="$t('delivery_restaurants')"
      :subtitle="$t('select_delivery_restaurant')"
    />
    
    <v-container>
      <v-row v-if="loading.initialize" justify="center" align="center" style="min-height: 400px;">
        <v-col cols="auto">
          <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
        </v-col>
      </v-row>

      <v-card
      v-else
      :key="index"
      v-for="(restaurant, index) in restaurants"
      :to="{
        name: 'restoran-dostava',
        params: { id: restaurant.id, name: restaurant.name },
      }"
      max-width="374"
      class="mx-auto my-12"
    >
      <v-img
        height="250"
        :src="
          conf.apiUrlBase + '/gallery/' + restaurant.id + '/' + restaurant.settings.logo
        "
      ></v-img>
      <v-card-title>{{ toLatin(restaurant.name) }}</v-card-title>
      <v-card-subtitle>{{ toLatin(restaurant.address) }}</v-card-subtitle>
      <v-card-text> </v-card-text>
    </v-card>
    </v-container>
  </div>
</template>

<script>
import conf from "@/config";
import hasSnackbar from "@/mixins/hasSnackbar";
import restaurantService from "@/services/restaurant";
export default {
  mixins: [hasSnackbar],
  data() {
    return {
      conf: conf,
      restaurants: null,
      loading: {
        initialize: false,
      },
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      if (this.loading.initialize) {
        console.warn("Initialize operation already in progress, skipping duplicate request");
        return;
      }

      this.loading.initialize = true;

      try {
        const res = await restaurantService.getDeliveryRestaurants();
        this.restaurants = res.data;
      } catch (error) {
        console.error("Error loading delivery restaurants:", error);
        this.showErrorSnackbar(error, this.$t("error_loading_restaurants"));
      } finally {
        this.loading.initialize = false;
      }
    },
  },
};
</script>
